





































































































import { PriceOptimizerState, PriceOptimizerUnit } from "@/models";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  name: "UnitQuickstats"
})
export default class UnitQuickstats extends Vue {
  // ===== Store ===== //
  @State("priceOptimizer") private readonly priceOptimizer!: PriceOptimizerState;
  // ===== Props ===== //
  @Prop({ required: true }) private readonly unit!: PriceOptimizerUnit;
  // ===== Methods ===== //
  public calculateLastMoveIn(date: Date): string {
    if (!date) {
      return "Unknown";
    }
    const today = moment.utc();
    const lastMoveIn = moment.utc(date);
    const diff = today.diff(lastMoveIn, "days");
    return `${diff} days ago`;
  }
  public canGenerateAverageRate(unit: PriceOptimizerUnit): boolean {
    return !!((unit.ipr_avg >= 0) && unit.new_rate);
  }
  public generateAverageRate(multiplier: number): string {
    const totalVacantCalculation = Math.ceil(this.unit.total_vacant * multiplier);
    const val1 = totalVacantCalculation * this.unit.new_rate;
    const val2 = this.unit.ipr_avg * this.unit.total_occupied;
    const val3 = this.unit.total_occupied + totalVacantCalculation;
    return `$${((val1 + val2) / val3).toFixed(2)}`;
  }
  // ===== Computed ===== //
  get daysToFill(): number | undefined {
    let result;
    if (!this.unit.total_vacant) {
      result = 0;
    }
    if (this.unit.total_vacant && this.unit.fill_rate < 1) {
      result = -1;
    }
    if (this.unit.total_vacant && this.unit.fill_rate > 0) {
      result = (this.unit.total_vacant / this.unit.fill_rate) * 30;
    }
    return result;
  }
}
